@if (state$ | async; as state) {
    <button mat-button (click)="browseFiles()" matTooltip="Upload">
        <mat-icon>file_upload</mat-icon>
        <span class="desktop"> Upload</span>
    </button>
    <input #file type="file" multiple (change)="onFilesAdded(state.streamId)" />
}
